module.exports = __webpack_public_path__ + "static/media/img-destaque-home.8b17ac71.jpg";